import { render, staticRenderFns } from "./fv_radios.vue?vue&type=template&id=2bfe7a02"
import script from "./fv_radios.vue?vue&type=script&lang=js"
export * from "./fv_radios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports